import { t05ProductIconSrc } from './t05FooterProducts';

export type T05StackPanelVariant = 'rows' | 'chat';

export type T05StackChatMock = {
  userQuestion: string;
  arkoRef?: string;
  arkoAnswer: string;
  badge: string;
  contextLabel?: string;
  contextBadge?: string;
};

export type T05ProductStackSection = {
  id: string;
  num: string;
  mono: string;
  title: string;
  description: string;
  detail: string;
  highlights: string[];
  iconFile: string;
  href: string;
  accent: string;
  panelVariant?: T05StackPanelVariant;
  panelTitle: string;
  panelRows: { label: string; badge: string }[];
  chatMock?: T05StackChatMock;
};

/** 7 Sub-Produkte — erweitert mit Detailtext, Highlights und v3-Icons */
export const T05_PRODUCT_STACK_SECTIONS: T05ProductStackSection[] = [
  {
    id: 'orbis',
    num: '01',
    mono: 'OR',
    title: 'Orbis — Tarife & Pakete',
    accent: '#405bff',
    iconFile: 'icon-orbis.jpg',
    description:
      'Professional ab 1.990 €/Monat oder Premium mit Litigation — Self-Hosted auf Ihrem EU-Server, ein Login, klare Sitze.',
    detail:
      'Orbis bündelt alle Module unter einem Vertrag: feste Sitzzahl, transparente Monatspreise und einmaliges Setup auf Ihrem Edge-Server in Frankfurt.',
    highlights: [
      'Professional & Premium — klar getrennte Leistungspakete',
      '5 Sitze inklusive, weitere nach Bedarf',
      'Kein US-Cloud-Zwang, volle Datenhoheit',
    ],
    href: '/produkt/orbis',
    panelTitle: 'orbis://tarife',
    panelRows: [
      { label: 'Professional · 5 Sitze', badge: '1.990 €' },
      { label: 'Premium · Litigation', badge: '4.990 €' },
      { label: 'Setup einmalig', badge: '1.990 €' },
    ],
  },
  {
    id: 'arko',
    num: '02',
    mono: 'AR',
    title: 'ARKO — KI-Rechtsassistent',
    accent: '#5b9dff',
    iconFile: 'icon-arko.jpg',
    description:
      'Chat mit Mandatskontext und quellenbelegten Antworten aus LEXCORE — lokal auf Ihrem Server, kein US-Cloud-Export.',
    detail:
      'ARKO antwortet mit Belegen aus dem österreichischen Rechtskern und Ihrer Akte. Hub-Modi für Recherche, Strukturieren und Entwurf — jede Aussage nachvollziehbar, kein Blackbox-Chat.',
    highlights: [
      'Recherche mit LEXCORE- und RIS-Quellen',
      'Mandatskontext aus Akte und Dokumenten',
      'Läuft auf Ollama am Edge — keine Mandantendaten in die US-Cloud',
    ],
    href: '/produkt/arko',
    panelVariant: 'chat',
    panelTitle: 'arko://session/recherche',
    panelRows: [],
    chatMock: {
      userQuestion: 'Welche Verjährungsfrist gilt für Schadenersatz nach § 1489 ABGB?',
      arkoRef: '§ 1489 ABGB',
      arkoAnswer: 'Drei Jahre ab Kenntnis.',
      badge: 'LEXCORE · RIS',
      contextLabel: 'Aktenkontext: Mandat Müller / Schadenersatz',
      contextBadge: 'Edge',
    },
  },
  {
    id: 'dokumente',
    num: '03',
    mono: 'DK',
    title: 'Dokumente & Akten',
    accent: '#ff9f43',
    iconFile: 'icon-dokumente.jpg',
    description:
      'Nextcloud, OnlyOffice und PocketBase in einer Akte — Mandantenordner mit klaren Rechten, kein Tool-Chaos.',
    detail:
      'Schriftsätze in OnlyOffice, Akten in Nextcloud, Stammdaten in PocketBase — ein Mandant, eine Oberfläche, klare Zugriffsrechte pro Rolle.',
    highlights: [
      'OnlyOffice für Schriftsätze und Verträge',
      'Nextcloud als Mandanten-Ablage',
      'PocketBase für strukturierte Aktenmetadaten',
    ],
    href: '/produkt/dokumente',
    panelTitle: 'orbis://mandant/akte',
    panelRows: [
      { label: 'Schriftsatz_Einreide.docx', badge: 'OnlyOffice' },
      { label: 'Mandantenmappe_2026/', badge: 'Nextcloud' },
      { label: 'Vermerk_Diktat.pdf', badge: 'ARKO' },
    ],
  },
  {
    id: 'litigation',
    num: '04',
    mono: 'LE',
    title: 'Litigation Engine',
    accent: '#f472b6',
    iconFile: 'icon-litigation.jpg',
    description:
      'Gegnerischen Schriftsatz hochladen, KI-Analyse und Strategie-PDF — Premium-Tarif, doppelte Pseudonymisierung.',
    detail:
      'Die Litigation Engine wertet gegnerische Schriftsätze strukturiert aus und liefert Strategie-Entwürfe — mit Opt-In-Pseudonymisierung für sensible Passagen.',
    highlights: [
      'Upload → Analyse → Strategie-PDF',
      'Premium-Tarif, klar abgegrenzt',
      'Doppelte Pseudonymisierung optional',
    ],
    href: '/produkt/litigation-engine',
    panelTitle: 'litigation://analyse',
    panelRows: [
      { label: 'Gegner_Schriftsatz.pdf', badge: 'Upload' },
      { label: 'Strategie-Entwurf', badge: 'Analyse' },
      { label: 'Pseudonymisiert', badge: 'Opt-In' },
    ],
  },
  {
    id: 'lexcore',
    num: '05',
    mono: 'LC',
    title: 'LEXCORE & BRAIN',
    accent: '#3dd6f5',
    iconFile: 'icon-lexcore.jpg',
    description:
      'Kuratierter österreichischer Rechtskern plus kanzlei-eigenes Wissen — jede Norm mit Beleg, kein Halluzinations-Blackbox.',
    detail:
      'LEXCORE liefert den zentralen MRG/ABGB-Kern mit RIS-Belegen. BRAIN ergänzt kanzlei-eigenes Wissen — getrennt, nachvollziehbar, für ARKO abrufbar.',
    highlights: [
      'Kuratierte Normen mit RIS-Verweis',
      'Kanzlei-Wissen in BRAIN — mandantenscharf',
      'Zentral bei ARKORBIT, Abruf am Edge',
    ],
    href: '/produkt/lexcore',
    panelTitle: 'lexcore://ris-kern',
    panelRows: [
      { label: 'MRG § 23 — Kündigung', badge: 'RIS' },
      { label: 'ABGB § 1295', badge: 'Kuratiert' },
      { label: 'Kanzlei-Wissen', badge: 'BRAIN' },
    ],
  },
  {
    id: 'diktat',
    num: '06',
    mono: 'DI',
    title: 'Diktat & Transkription',
    accent: '#a78bfa',
    iconFile: 'icon-diktat.jpg',
    description:
      'Sprachnachricht → Aktenvermerk-PDF auf Ihrem Server: Whisper, Ollama, Gotenberg — 0 % Daten verlassen Ihren Edge.',
    detail:
      'Diktate per Matrix oder Upload, Transkription mit Whisper large-v3 lokal, Zusammenfassung per Ollama — PDF-Vermerk via Gotenberg direkt in die Akte.',
    highlights: [
      'Whisper large-v3 am Edge',
      'Ollama für Struktur und Vermerk',
      'Gotenberg-PDF ohne Cloud-Export',
    ],
    href: '/produkt/diktat',
    panelTitle: 'diktat://pipeline',
    panelRows: [
      { label: 'Audio-Upload', badge: 'Matrix' },
      { label: 'Whisper large-v3', badge: 'Lokal' },
      { label: 'PDF Vermerk', badge: 'Gotenberg' },
    ],
  },
  {
    id: 'portal',
    num: '07',
    mono: 'PO',
    title: 'Kanzlei-Portal',
    accent: '#34d399',
    iconFile: 'icon-portal.jpg',
    description:
      'Ein Web-Zugang zu allen Orbis-Diensten — Dashboard, Mandatsübersicht, Sitzverwaltung, ein Login für die ganze Kanzlei.',
    detail:
      'Das Kanzlei-Portal ist der zentrale Einstieg: Mandatsübersicht, ARKO, Akte, Diktat und Workflows — ein Login, klare Rollen, Sitzverwaltung inklusive.',
    highlights: [
      'Dashboard mit Live-Mandatsübersicht',
      'ARKO, Akte und Diktat in einer Shell',
      'Sitz 3 von 5 — Professional-Tarif',
    ],
    href: '/produkt/portal',
    panelTitle: 'portal://dashboard',
    panelRows: [
      { label: 'Mandatsübersicht', badge: 'Live' },
      { label: 'ARKO · Akte · Diktat', badge: 'Ein Login' },
      { label: 'Sitz 3 von 5', badge: 'Professional' },
    ],
  },
];

export function t05StackIconSrc(iconFile: string): string {
  return t05ProductIconSrc(iconFile);
}
